// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"72":"Cart","187":"NotFound","782":"FullProduct"}[chunkId] + "." + {"72":"c1586dd8","187":"f7235b54","782":"47cfc64a"}[chunkId] + ".chunk.js";
};